'use strict'

function formatOptions (options) {
  if (!options || options === undefined) {
    throw new Error('textToImg: parameter is not valid')
  }

  if (!options.font) {
    throw new Error('textToImg: parameter font is required')
  }

  if (!options.textString) {
    throw new Error('textToImg: parameter textString is required')
  }

  if (typeof options.font === 'string') {
    return options
  }

  options.font = options.font || ['12px', 'Arial']
  options.font = options.font.join(' ')
  options.fillStyle = options.color || 'black'
  options.textString = options.textString || 'textToImg !'
  options.paddingX = options.paddingX || 0
  options.paddingY = options.paddingY || 0
  options.transform = options.transform || 0

  return options
}

function generateImage (options) {
  const configs = formatOptions(options)
  const uniquetime = new Date().getUTCMilliseconds()
  const canvasSelectorDom = document.createElement('CANVAS')
  canvasSelectorDom.setAttribute('width', configs.width)
  canvasSelectorDom.setAttribute('height', configs.height)
  canvasSelectorDom.setAttribute('id', 'textToImg-' + uniquetime)

  const context = canvasSelectorDom.getContext('2d')
  context.font = configs.font
  context.fillStyle = configs.fillStyle
  context.fillText(configs.textString, configs.paddingX, configs.paddingY)

  return canvasSelectorDom.toDataURL()
}

export default function (options) {
  const string = options.textString
  const base64Image = generateImage(options)

  return {
    string,
    base64Image
  }
}
